var includes = function includes(str, val) {
  return str.indexOf(val) !== -1;
};
export default includes;